import { ReactElement } from 'react';
import { Box } from '@chakra-ui/react';
import { Z_INDEX } from 'styles/zIndex';
import { useAdminImpersonationSession } from 'hooks/useAdminImpersonationSession';
import { useUser } from 'utils/auth';

type AdminBarProps = {
  isInApp: boolean;
};

export const AdminBar = ({ isInApp }: AdminBarProps): ReactElement | null => {
  const user = useUser();
  const { isAdminMode, handleStopAdminMode } = useAdminImpersonationSession();

  if (!isAdminMode || !isInApp) {
    return null;
  }

  return (
    <Box
      w="100%"
      bg="red.500"
      color="white"
      p="8px"
      textAlign="center"
      fontSize="sm"
      fontWeight="medium"
      cursor="pointer"
      onClick={handleStopAdminMode}
      position="sticky"
      top="0"
      zIndex={Z_INDEX.NAVBAR + 1}
      _hover={{
        bg: 'red.600',
      }}
    >
      {user.data?.email} - Admin Mode aktiv (Klicken, um zu beenden)
    </Box>
  );
};
